import styled from 'styled-components';
import { withFancyScrollbar } from '../../../../../constants/styleUtils/styleUtils';

export const Wrapper = styled.div`
	margin-top: 2rem;
	overflow-y: auto;
	padding: 3rem;
	flex: 1;
	${withFancyScrollbar};
`;

